import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { getEntities } from '../utils/getEntities';
import { IScene, ISceneConfig } from 'types/domain/scene';
import { IAction } from 'types/domain/action';
import { IModule } from 'types/domain/module';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => (id ? id : state.state[EntityTypes.MODULE]);
const upload = (state: RootState) => state.core.upload;

export const selectModulePreviewOptions = createSelector(
  [entity, id, upload],
  (entity: IEntityReducer, id: number, upload) => parseModuleImages(entity, id),
);

export function parseModuleImages(entity, id) {
  const module: IModule = entity[EntityTypes.MODULE][id];

  if(!module) return [];

  return getEntities(entity, EntityTypes.ACTION, 'moduleId', id)
    .filter((action: IAction) => !!action.sceneId)
    .sort((a: IAction, b: IAction) =>
      entity[EntityTypes.NODE][a.nodeId]?.x > entity[EntityTypes.NODE][b.nodeId]?.x ? -1 : 1,
    )
    .reduce(
      (prev, action: IAction) => {
        const scene: IScene = entity[EntityTypes.SCENE][action.sceneId];

        if (!scene) return prev;

        const sConfig: ISceneConfig = entity[EntityTypes.SCENE_CONFIG][scene.sceneConfigId];
        const aConfig: ISceneConfig = entity[EntityTypes.SCENE_CONFIG][action.sceneConfigId];

        if (prev.length > 3) return prev;

        if (aConfig && aConfig.imageId) return [...prev, entity[EntityTypes.IMAGE][aConfig.imageId]];
        if (sConfig && sConfig.imageId) return [...prev, entity[EntityTypes.IMAGE][sConfig.imageId]];

        return prev;
      },
      module.imageId ? [entity[EntityTypes.IMAGE][module.imageId]] : [],
    );
}
